import StatisticListContainer from './StatisticListContainer';
export default StatisticListContainer;
